class CreditRequestStatusData {
    static data() {
        return {
            rassmotrenie: {slug: "rassmotrenie", label: "Рассмотрение", class: "rassmotrenie", short_id: null},
            otkaz: {slug: "otkaz", label: "Отказ", class: "otkaz", short_id: 1},
            otkaz_skoring: {slug: "otkaz_skoring", label: "Отказ скоринг", class: "otkaz_skoring", short_id: 2},
            otkaz_ds: {slug: "otkaz_ds", label: "Отказ ДС", class: "otkaz_ds", short_id: 3},
            np_vozrast: {slug: "np_vozrast", label: "НП возраст", class: "np_vozrast", short_id: 1},
            np_region: {slug: "np_region", label: "НП регион", class: "np_region", short_id: 2},
            np_vu: {slug: "np_vu", label: "НП ВУ", class: "np_vu", short_id: 3},
            np_fssp: {slug: "np_fssp", label: "НП ФССП", class: "np_fssp", short_id: 4},
            odobren: {slug: "odobren", label: "Одобрен", class: "odobren", short_id: null},
            limit_po_klientu: {slug: "limit_po_klientu", label: "Лимит по клиенту", class: "limit_po_klientu", short_id: 1},
            limit_po_ts: {slug: "limit_po_ts", label: "Лимит по ТС", class: "limit_po_ts", short_id: 2},
            soglasovanie_ts: {slug: "soglasovanie_ts", label: "Согласование ТС", class: "soglasovanie_ts", short_id: "С"},
            ozidanie: {slug: "ozidanie", label: "Ожидание", class: "ozidanie", short_id: "О"},
            dokumenty_gotovy: {slug: "dokumenty_gotovy", label: "Документы готовы", class: "dokumenty_gotovy", short_id: "Г"},
            oformlen: {slug: "oformlen", label: "Оформлен", class: "oformlen", short_id: null},
            ne_otpravljat: {slug: "ne_otpravljat", label: "Не отправлять", class: "ne_otpravljat", short_id: null},
            chernovik: {slug: "chernovik", label: "Черновик", class: "chernovik", short_id: null},
            skoring_otpravit: {slug: "skoring_otpravit", label: "Скоринг отправить", class: "skoring_otpravit", short_id: null},
        };
    }
    static dataAsArray() {
        let arr = [];
        let data = this.data();
        for (status in data) {
            arr.push(data[status])
        }
        return arr;
    }
    static forSelect() {
        return this.dataAsArray().map(function (item) {
            return {id: item.slug, text: item.label};
        })
    }
    // Группы меню статусов: column — колонка меню (0 — левая, 1 — правая), порядок групп внутри колонки сверху вниз
    static groups() {
        return [
            {key: "in_work", label: "В работе", column: 0, statuses: ["chernovik", "skoring_otpravit", "rassmotrenie"]},
            {key: "approved", label: "Одобрение и оформление", column: 0, statuses: ["odobren", "soglasovanie_ts", "ozidanie", "dokumenty_gotovy", "oformlen"]},
            {key: "limits", label: "Лимиты", column: 0, statuses: ["limit_po_klientu", "limit_po_ts"]},
            {key: "not_suitable", label: "Не подходит", column: 1, statuses: ["np_vozrast", "np_region", "np_vu", "np_fssp"]},
            {key: "rejections", label: "Отказы", column: 1, statuses: ["otkaz", "otkaz_skoring", "otkaz_ds"]},
            {key: "sending", label: "Отправка", column: 1, statuses: ["ne_otpravljat"]},
        ];
    }
    // Счётчики в окне кредитных заявок. «Не отправлять» и пустой статус не считаются
    static summaryGroups() {
        let groups = _.keyBy(this.groups(), 'key');
        return [
            {key: "approved", label: "одобрено", color: "odobren", statuses: groups.approved.statuses},
            {key: "limits", label: "лимиты", color: "limit_po_klientu", statuses: groups.limits.statuses},
            {key: "rejections", label: "отказы", color: "otkaz", statuses: groups.rejections.statuses},
            {key: "in_work", label: "в работе", color: "rassmotrenie", statuses: groups.in_work.statuses},
            {key: "not_suitable", label: "не проходит", color: "np_vozrast", statuses: groups.not_suitable.statuses},
        ];
    }
}

export default CreditRequestStatusData;
